export const AimIIcon = () => <svg width="6" className='aim-i' height="37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.79863 37C5.90909 37 5.99863 36.9105 5.99863 36.8V0.200001C5.99863 0.0895438 5.90909 0 5.79863 0H0.3875C0.277043 0 0.1875 0.0895431 0.1875 0.2V36.8C0.1875 36.9105 0.277043 37 0.3875 37H5.79863Z" fill="#FF9900" />
</svg>

